import { extendTheme } from '@blockanalitica/ui';
import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { colors } from './colors';
import { card } from './components/card';
import { heatmapCell } from './components/heatmapCell';
import { kpiFooter } from './components/kpiFooter';
import { kpiHeader } from './components/kpiHeader';
import { linkButton } from './components/linkButton';
import { table } from './components/table';
import { tableCell } from './components/tableCell';
import { headerCell } from './components/headerCell';
import { sortingButton } from './components/sortingButton';
import { kpiBody } from './components/kpiBody';
import { kpiCardFooter } from './components/kpiCardFooter';
import { displaySwitch } from './components/displaySwitch';
import { displaySwitchOption } from './components/displaySwitchOption';
import { chartKpiSubValue } from './components/chartKpiSubValue';
import { chartKpiValue } from './components/chartKpiValue';
import { chartKpiLabel } from './components/chartKpiLabel';
import { dropdown } from './components/dropdown';
import { dropdownHeader } from './components/dropdownHeader';
import { dropdownList } from './components/dropdownList';
import { dropdownOption } from './components/dropdownOption';
import { dropdownOptionSelected } from './components/dropdownOptionSelected';
import { listItem } from './components/listItem';
import { listHeader } from './components/listHeader';
import { paginationCurrentNavigation } from './components/paginationCurrentNavigation';
import { collapsableSidebar } from './components/collapsableSidebar';
import { kpiCardValue } from './components/kpiCardValue';
import { heading } from './components/heading';
import { badge } from './components/badge';
import { input } from './components/input';
import { actionCard } from './components/actionCard';
import { actionCardAction } from './components/actionCardAction';
import { actionCardContent } from './components/actionCardContent';
import { paginationContainer } from './components/paginationContainer';
import { textSearchFilterIcon } from './components/textSearchFilterIcon';
import sizes from './sizes';
import space from './space';

export const theme: Theme = extendTheme({
  rootFontSize: '13px',
  charts: {
    minFontSize: 9,
    maxFontSize: 12
  },
  colors,
  sizes,
  space,
  components: [
    card,
    chartKpiSubValue,
    chartKpiValue,
    chartKpiLabel,
    collapsableSidebar,
    displaySwitch,
    displaySwitchOption,
    dropdown,
    dropdownHeader,
    dropdownList,
    dropdownOption,
    dropdownOptionSelected,
    heatmapCell,
    kpiBody,
    kpiCardFooter,
    kpiFooter,
    kpiHeader,
    linkButton,
    listHeader,
    listItem,
    paginationCurrentNavigation,
    table,
    tableCell,
    headerCell,
    sortingButton,
    badge,
    heading,
    kpiCardValue,
    input,
    actionCard,
    actionCardAction,
    actionCardContent,
    paginationContainer,
    textSearchFilterIcon
  ]
});
